<div class="header">
  <!-- Desktop Carousel -->
  <div class="d-none d-sm-block">
    <div id="carouselExampleControls" class="carousel slide">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          *ngFor="let slide of slides; let i = index"
          [class.active]="i === currentSlide"
          >
          <img class="d-block w-100" [src]="slide.image" [alt]="slide.alt" />
        <!-- <div class="images">
          <img class="d-block w-100 image1" [src]="slide.image" [alt]="slide.alt" />
          <img  class="d-block w-100 image2" [src]="(i+1 === slides.length) ? slides[0].image : slides[i+1].image" [alt]="slide.alt" />
        </div> -->
        </div>
      </div>
      <button class="carousel-control-prev" (click)="prevSlide()" type="button">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" (click)="nextSlide()" type="button">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div class="carousel-indicators dots-top">
      <span
        *ngFor="let slide of slides; let i = index"
        [class.active]="i === currentSlide"
        (click)="goToSlide(i)"
        class="dot"
      ></span>
    </div>
  </div>

  <!-- Mobile Carousel -->
  <div class="d-block d-sm-none">
    <div id="carouselExampleControlsMobile" class="carousel slide">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          *ngFor="let slide of resSlides; let i = index"
          [class.active]="i === currentSlide"
        >
          <img class="d-block w-100" [src]="slide.image" [alt]="slide.alt" />
        </div>
      </div>

    </div>

    <div class="carousel-indicators dots-top">
      <span
        *ngFor="let slide of resSlides; let i = index"
        [class.active]="i === currentSlide"
        (click)="goToSlide(i)"
        class="dot"
      ></span>
    </div>
  </div>

  <!-- Quotes Section -->
  <div class="header-name text-center mt-3 d-none d-sm-block ">
    <div
      *ngFor="let quote of quotes; let i = index"
      [class.active]="i === currentSlide"
      class="carousel-item text-container"
      style="margin-right: 10px;"
    >
      <p
        style="margin-top: 15px; line-height: 40px; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8), -2px -2px 4px rgba(0, 0, 0, 0.8);"
      >
        {{ quote.p }}
      </p>
    </div>
  </div>
</div>






